const ShareBorderIcon = ({ className }: { className: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    data-name="Layer 2"
    viewBox="0 0 23.23 24.12"
    className={className}
    data-palette="ShareBorderIcon">
    <defs>
      <style>
        {
          '.cls-2{stroke:currentColor}.cls-2,.cls-3{fill:none}.cls-2{stroke-width:1.5px}.cls-3{stroke:var(--brand-bg-primary);stroke-width:1.5px}'
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path d="m15.12 17.06-7-4M15.12 7.06l-7 4" className="cls-3" />
      <circle cx={6.12} cy={12.06} r={3} className="cls-2" />
      <circle cx={17.12} cy={6.06} r={3} className="cls-2" />
      <circle cx={17.12} cy={18.06} r={3} className="cls-2" />
      <rect
        width={22.23}
        height={23.12}
        x={0.5}
        y={0.5}
        rx={4.32}
        ry={4.32}
        className="cls-2"
        style={{
          fill: 'none',
          stroke: 'currentColor',
        }}
      />
    </g>
  </svg>
);

export default ShareBorderIcon;
